import { render, staticRenderFns } from "./names.vue?vue&type=template&id=67b5c3a9&"
import script from "./names.vue?vue&type=script&lang=js&"
export * from "./names.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports